// The org's Tuvis OIDC identity for an S3 destination that assumes an IAM role (customS3 and
// secure storage S3): the provider URL the admin trusts in AWS, and the external id (its
// last segment is the org) the role's trust policy matches.

export const newOidcExternalId = (orgId: string | undefined) => `app:${Math.random().toString(16).substring(2, 10).toUpperCase()}:${orgId}`;

export const oidcProviderUrl = (orgId: string | undefined) =>
  `https://api-${import.meta.env.VITE_API_DEFAULT_POD?.toString() || "us1"}.tuvis.com/message/destinations/${orgId}/oidc`;
